import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import React from "react";
import config from "@src/utilities/config";

const name = "SquareTestNumbers";

interface IProps {
    webSDK: boolean;
}

const SquareTestNumbers: React.FC<IProps> = ({ webSDK }) => {
    if (!config.debug) return null;

    return (!webSDK ? (<Grid
        size={{
            xs: 12,
            sm: 12
        }}>
        <Paper elevation={2} sx={{ padding: 1, minWidth: "30em" }}>
            <Alert severity="success" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Card Accepted - 4111 1111 1111 1111</Alert>
            <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Generic Decline - 4000 0000 0000 0002</Alert>
            <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Expired Card Decline - expiry 01/40</Alert>
        </Paper>
    </Grid>) : (<Grid
        size={{
            xs: 12,
            sm: 12
        }}>
        <Paper elevation={2} sx={{ padding: 1, minWidth: "30em" }}>
            <Alert severity="success" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Card Accepted - 4310 0000 0020 1019</Alert>
            <Alert severity="success" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Card Accepted - 5500 0000 0020 1016</Alert>
            <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Generic Decline - 4000 0000 0000 0002</Alert>
            <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Card Declined - 6011 0000 0020 1016</Alert>
            <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Card CVV incorrect - CVV: 911</Alert>
            <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Expired Card Decline - expiry 01/40</Alert>
        </Paper>
    </Grid>));
}

SquareTestNumbers.displayName = name;

export default React.memo(SquareTestNumbers);

